export const Types = {
    SAVE_LIST_SLIDE_HOME: 'SAVE_LIST_SLIDE_HOME',
}
